// src/routes/PrivateRoute.tsx
import { Navigate } from 'react-router-dom';
import { useAuth } from 'sections/authentication/context/UseAuth';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();
  if (isLoading) return null;
  return user?.token ? <>{children}</> : <Navigate to="/login" replace />;
};
